<form class="form-wrapper"
    [errorMessage]="errorMessage"
    [formGroup]="vm"
    [simpleMode]="isSimpleMode">
    <n-form-item
        [label]="str.title.name"
        [required]="true">
        <div class="custom-width">
            <input type="text"
                pInputText
                formControlName="name"
                [placeholder]="errorMessage.name.rangeByteLength"
                id="create-hyperCDP-schedule-Name"/>
        </div>
    </n-form-item>
    <n-form-item [label]="str.title.vStoreLab" *ngIf="!isSimpleMode"
        [required]="!vstore || !vstore.value">
        <n-select #vstoreSelect
            id="vstore_dropdown"
            formControlName="vstoreItem"
            [rest]="vstoreRest"
            [filter]="true"
            [labelField]="'NAME'"
            [valueField]="'ID'"
            style="width: 3rem"
            (onChange)="selectedVstoreChange($event.option)"
            *ngIf="!vstore || !vstore.value">
        </n-select>
        <div class="n-form-item-text" *ngIf="vstore && vstore.value">{{vstore.label}}</div>
    </n-form-item>
    <n-form-item [label]="str.title.description">
        <div class="custom-width">
            <textarea pInputTextarea
                rows="2"
                cols="40"
                formControlName="description"
                id="create-hyperCDP-schedule-description"
                [placeholder]="errorMessage.description.rangeByteLength">
            </textarea>
        </div>
    </n-form-item>
</form>

<n-tab [ngClass]="{'n-tab-wrap': type === ScheduleTypeE.File}" *ngIf="!isSimpleMode">
    <n-tab-item *ngIf="type === ScheduleTypeE.Block"
        [header]="str.title.pg"
        [permission]="['lun_snapshot_W']"
        #protectGroupTab>
        <ng-template nTemplate>
            <n-loading [visible]="loading"></n-loading>
            <n-transfer-table #pgtt
                style="height: 350px"
                id="create-cdpschedule-transfer-pg-table"
                [config]="tableConfig"
                [leftColumnDefs]="PGcolumnDefs"
                [rightColumnDefs]="PGcolumnDefs"
                [leftTitle]="str.title.leftPgTitle"
                [rightTitle]="str.title.rightPgTitle"
                [rest]="protectRest"
                [(selection)]="selection">
            </n-transfer-table>
        </ng-template>
    </n-tab-item>
    <n-tab-item *ngIf="type === ScheduleTypeE.Block"
        [header]="str.title.lun"
        [permission]="['lun_snapshot_W']"
        #LunTab>
        <ng-template nTemplate>
            <n-transfer-table #luntt
                style="height: 350px"
                id="create-create-cdpschedule-transfer-lun-table"
                [config]="tableConfig"
                [leftColumnDefs]="LUNcolumnDefs"
                [rightColumnDefs]="LUNcolumnDefs"
                [leftTitle]="str.title.leftLunTitle"
                [rightTitle]="str.title.rightLunTitle"
                [rest]="lunRest"
                [(selection)]="selection">
            </n-transfer-table>
        </ng-template>
    </n-tab-item>
    <n-tab-item *ngIf="type === ScheduleTypeE.File"
        [header]="str.title.fs"
        [permission]="['fs_snapshot_W']"
        #FsTab>
        <ng-template nTemplate>
            <n-transfer-table #fstt
                style="height: 350px"
                id="create-create-cdpschedule-transfer-fs-table"
                [config]="tableConfig"
                [leftColumnDefs]="FScolumnDefs"
                [rightColumnDefs]="FScolumnDefs"
                [leftTitle]="str.title.leftFsTitle"
                [rightTitle]="str.title.rightFsTitle"
                [rest]="fsRest"
                [(selection)]="selection">
            </n-transfer-table>
        </ng-template>
    </n-tab-item>
</n-tab>
